const updates = [
  {
    id: 1,
    date: '2025-07-31',
    tag: '新片上线',
    title: '《异形：夺命舰》高清版正式入库',
    desc: '科幻恐怖经典系列最新作，异形宇宙全新篇章震撼来袭，高清画质已上线，影迷速来围观。',
  },
  {
    id: 2,
    date: '2025-07-30',
    tag: '剧集更新',
    title: '《庆余年第二季》第 28 集更新',
    desc: '范闲朝堂智斗再升级，北齐使团入京风云突变，本集高能反转不断，配合 1080P 高清画质。',
  },
  {
    id: 3,
    date: '2025-07-29',
    tag: '片库扩充',
    title: '新增 50 部 IMDb 高分经典影片',
    desc: '《教父》《肖申克的救赎》《蝙蝠侠：黑暗骑士》等影史经典一次性入库，全高清画质呈现。',
  },
  {
    id: 4,
    date: '2025-07-28',
    tag: '综艺上线',
    title: '《歌手2025》总决赛完整版上线',
    desc: '年度音乐盛典终极对决，多位实力唱将同台竞演，全程高能无尿点，高清无损音质体验。',
  },
  {
    id: 5,
    date: '2025-07-27',
    tag: '动漫更新',
    title: '《凡人修仙传》年番第 156 话更新',
    desc: '韩立元婴大成冲击化神，灵界冒险全面展开，国漫顶流持续高能输出，每周准时更新。',
  },
  {
    id: 6,
    date: '2025-07-26',
    tag: '系统优化',
    title: '播放器全面升级，加载速度提升 40%',
    desc: '技术团队完成核心播放引擎升级，视频启播速度大幅提升，弱网环境下也能流畅观影。',
  },
  {
    id: 7,
    date: '2025-07-25',
    tag: '新片上线',
    title: '《死侍与金刚狼》高清中字版入库',
    desc: '漫威年度重磅，贱贱与狼叔首次大银幕合体，笑点密集动作火爆，院线级观影体验。',
  },
  {
    id: 8,
    date: '2025-07-24',
    tag: '剧集完结',
    title: '《繁花》全集 30 集打包上线',
    desc: '王家卫首部电视剧全剧完结，上海滩三十年风云变幻，沪语原声版与普通话版双版本入库。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-100/70">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-wide mb-3">
            实时
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            最新更新
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg mx-auto">
            窝窝影院每日内容动态与平台升级实录
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-300/60"></div>

          <div className="space-y-6">
            {updates.map((update) => (
              <div key={update.id} className="relative flex gap-4 md:gap-6 pl-10 md:pl-12">
                <div className="absolute left-3 md:left-3.5 top-1.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex-1 bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400">{update.date}</span>
                    <span className="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                      {update.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-1.5">
                    {update.title}
                  </h3>
                  <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                    {update.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}